import { BannerText } from "components/BannerText"
import { useTranslation } from "hooks/useTranslation"
import { styled} from 'stitches.config'

export const PerfectlyFormulated = () => {
const { t } = useTranslation()

    const Header = styled('h2', {
        fontSize: '$h3',
        color: '$accent-white',
        textAlign: 'center',
        width: '100%',

        '@bp2': {
            fontSize: '$h2',
            maxWidth: '1200px',
        }
    })

    return (
        <BannerText background='secondary-500'>
            <Header>
                {t('products-v2:all-products.nutritionist.message')}
            </Header>
        </BannerText>
    )
}